var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[(_vm.Tab.payload==0)?_c('your-data-filter'):_vm._e(),(_vm.Tab.payload==1)?_c('benchmark-filter'):_vm._e(),(_vm.Tab.payload==2)?_c('segment-filter'):_vm._e(),(_vm.Tab.payload==3)?_c('cohort-filter'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }